import {
  keepPreviousData,
  useMutation,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query';
import { container } from '@/app/container';
import { CatalogRepositoryToken } from '../../di/tokens';

export function useFeatures(page = 1, perPage = 10, includeDeprecated = false) {
  const repository = container.resolve(CatalogRepositoryToken);
  return useQuery({
    queryKey: ['catalog', 'features', page, perPage, includeDeprecated],
    queryFn: () => repository.listFeatures({ page, perPage, includeDeprecated }),
    staleTime: 1000 * 60 * 5,
    placeholderData: keepPreviousData,
  });
}

export function useUpdateFeatureScopes(featureId: string) {
  const queryClient = useQueryClient();
  const repository = container.resolve(CatalogRepositoryToken);
  return useMutation({
    mutationFn: (scopeIds: string[]) =>
      repository.updateFeatureScopes(featureId, { scopeIds }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['catalog', 'features'] });
    },
  });
}
